<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Portal-Complaint-Document-List",
  short_name: "Complaint Documents",
  path: "list",
  menu: true,
  mounted() {
    this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
